import ContentHeader from '@Components/ContentHeader'
import React from 'react'

const WorkMergeHeader = () => (
    <ContentHeader
        title="Work Merge Tool"
        descriptionElement={
            <>
                <p>
                    Use this tool to combine duplicate works that represent the same musical composition into a single
                    record.
                </p>
                <p>
                    Only one work merge request can be submitted at a time. Please complete each request before starting
                    another.
                </p>
            </>
        }
    />
)

export default WorkMergeHeader
